'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Body = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Body = exports.Body = function Body(_ref) {
  var noscroll = _ref.noscroll,
      children = _ref.children;

  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)('mod-Dialog_Body', {
      'mod-Dialog_Body-noscroll': noscroll
    })
  }, children);
};